import React from 'react'
import { Provider } from 'react-redux'
import { store } from 'store'
import UserProfile from './components/userProfile'
import '@rankmi/rankmi-table/dist/index.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/700.css'

interface IUserProfile {
  locale?: any
  userId?: number
  userToken?: string
  padding: string
}

export const LmsUserProfile = ({
  locale = {},
  userId,
  userToken,
  padding
}: IUserProfile) => {
  return (
    <Provider store={store}>
      <UserProfile
        locale={locale}
        userId={userId}
        userToken={userToken}
        padding={padding}
      />
    </Provider>
  )
}
